<template>
  <div class="symptoms">
    <div class="container">
      <h1>Симптомы и признаки</h1>
      <div class="symptoms-girl">
        <div class="symptoms-girl-items">
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Заложенность носа</span></div>
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Чихание</span></div>
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Боль в горле</span></div>
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Боль в мышцах</span></div>
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Ощущение тяжести в грудной клетке</span></div>
          <div class="symptoms-girl-item"><Checkbox/><span class="symptoms-girl-item-text">Повышение температуры, озноб</span></div>
        </div>
        <img src="/images/girl-and-symptoms.png" alt="симптомы">
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/assets/svg/infographics/checkbox.svg'

export default {
  components: {
    Checkbox
  }
}
</script>

<style lang="scss" scoped>
.symptoms {
  padding-top: 60px;
  &-girl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    &-item {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 30px;
      &:first-child {
        margin-bottom: 36px;
      }
      &-text {
        margin-top: -5px;
      }
    }
    & img {
      vertical-align: middle;
    }
  }
}
@media screen and (max-width: 767px) {
  .symptoms {
    padding-top: 50px;
    padding-bottom: 50px;
    &-girl {
      display: block;
      & img {
        display: none;
      }
      &-item {
        justify-content: flex-start;
        margin-bottom: 10px;
        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>